// import React, { useEffect } from 'react';
// import { Icon, UserRoundPlus, X } from 'lucide-react';
// import { useForm } from 'react-hook-form';
// import { zodResolver } from '@hookform/resolvers/zod';
// import { z } from 'zod';
// import { useCreateAdmin } from '../hooks/useAdminMutations';
// import { useRoles } from 'features/role/hooks/useRoles';

// // Zod validation schema
// const adminSchema = z
//   .object({
//     name: z
//       .string()
//       .min(1, 'Name is required')
//       .min(2, 'Name must be at least 2 characters')
//       .max(50, 'Name must be less than 50 characters'),
//     email: z.string().min(1, 'Email is required').email('Invalid email address'),
//      phoneNumber: z
//     .string()
//     .optional()
//     .refine((val) => {
//       if (!val || val.trim() === '') return true; // optional
//       return /^[6-9]\d{9}$/.test(val); // Indian number rule
//     }, {
//       message: 'Enter a valid Indian phone number',
//     }),

//   role: z.string().min(1, 'Role is required'),
//     password: z
//       .string()
//       .min(1, 'Password is required')
//       .min(8, 'Password must be at least 8 characters')
//       .max(100, 'Password must be less than 100 characters'),
//     confirmPassword: z.string().min(1, 'Please confirm your password'),
//   })
//   .refine((data) => data.password === data.confirmPassword, {
//     message: "Passwords don't match",
//     path: ['confirmPassword'],
//   });

// export const AddAdminModal = ({ isOpen, onClose }) => {
//   const { mutate: createAdmin, isPending } = useCreateAdmin();
//   const { data: roles } = useRoles({ limit: 99, isActive: true });

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     reset,
//   } = useForm({
//     resolver: zodResolver(adminSchema),
//     mode: 'onChange',
//     defaultValues: {
//       name: '',
//       email: '',
//       phoneNumber: '',
//       password: '',
//       confirmPassword: '',
//       role: '',
//     },
//   });

//   // Reset form when modal closes
//   useEffect(() => {
//     if (!isOpen) {
//       reset();
//     }
//   }, [isOpen, reset]);

//   const onSubmit = (data) => {
//     const { phoneNumber, ...submitData } = data;
//     const finalData = phoneNumber ? { ...submitData, phoneNumber } : submitData;

//     createAdmin(finalData, {
//       onSuccess: () => {
//         onClose();
//         reset();
//       },
//     });
//   };

//   if (!isOpen) return null;

//   return (
//     <div className='fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm overflow-y-auto'>
//       <div className='bg-card rounded-lg shadow-xl w-full max-w-2xl border border-border my-8'>
//         {/* Header */}
//         <div className='flex items-center justify-between px-6 py-4 border-b border-border'>
//           <h3 className='text-lg font-semibold text-foreground'>Add New Admin</h3>
//           <button
//             onClick={onClose}
//             className='text-muted-foreground hover:text-foreground transition-colors'
//             type='button'
//           >
//             <X size={20} />
//           </button>
//         </div>

//         {/* Form */}
//         <form onSubmit={handleSubmit(onSubmit)} className='p-6'>
//           <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
//             {/* Name */}
//             <div>
//               <label className='block text-sm font-medium text-foreground mb-1'>
//                 Name <span className='text-destructive'>*</span>
//               </label>
//               <input
//                 type='text'
//                 {...register('name')}
//                 className={`w-full px-3 py-2 ${errors.name ? 'border-destructive' : ''}`}
//                 placeholder='Enter admin name'
//               />
//               {errors.name && <p className='mt-1 text-xs text-destructive'>{errors.name.message}</p>}
//             </div>

//             {/* Email */}
//             <div>
//               <label className='block text-sm font-medium text-foreground mb-1'>
//                 Email <span className='text-destructive'>*</span>
//               </label>
//               <input
//                 type='email'
//                 {...register('email')}
//                 className={`w-full px-3 py-2 ${errors.email ? 'border-destructive' : ''}`}
//                 placeholder='admin@example.com'
//               />
//               {errors.email && <p className='mt-1 text-xs text-destructive'>{errors.email.message}</p>}
//             </div>

//             {/* Phone Number */}
//             <div>
//               <label className='block text-sm font-medium text-foreground mb-1'>
//                 Phone Number <span className='text-muted-foreground text-xs'>(Optional)</span>
//               </label>
//               <input
//                 type='tel'
//                 {...register('phoneNumber')}
//                 className={`w-full px-3 py-2 ${errors.phoneNumber ? 'border-destructive' : ''}`}
//                 placeholder='1234567890'
//               />
//               {errors.phoneNumber && <p className='mt-1 text-xs text-destructive'>{errors.phoneNumber.message}</p>}
//             </div>

//             {/* Role */}
//             <div>
//               <label className='block text-sm font-medium text-foreground mb-1'>
//                 Role <span className='text-destructive'>*</span>
//               </label>
//               <select {...register('role')} className={`w-full px-3 py-2 ${errors.role ? 'border-destructive' : ''}`}>
//                 <option value=''>Select a role</option>
//                 {roles?.data?.map((role) => (
//                   <option key={role._id} value={role._id}>
//                     {role.name}
//                   </option>
//                 ))}
//               </select>
//               {errors.role && <p className='mt-1 text-xs text-destructive'>{errors.role.message}</p>}
//             </div>

//             {/* Password */}
//             <div>
//               <label className='block text-sm font-medium text-foreground mb-1'>
//                 Password <span className='text-destructive'>*</span>
//               </label>
//               <input
//                 type='password'
//                 {...register('password')}
//                 className={`w-full px-3 py-2 ${errors.password ? 'border-destructive' : ''}`}
//                 placeholder='Min. 8 characters'
//               />
//               {errors.password && <p className='mt-1 text-xs text-destructive'>{errors.password.message}</p>}
//             </div>

//             {/* Confirm Password */}
//             <div>
//               <label className='block text-sm font-medium text-foreground mb-1'>
//                 Confirm Password <span className='text-destructive'>*</span>
//               </label>
//               <input
//                 type='password'
//                 {...register('confirmPassword')}
//                 className={`w-full px-3 py-2 ${errors.confirmPassword ? 'border-destructive' : ''}`}
//                 placeholder='Re-enter password'
//               />
//               {errors.confirmPassword && (
//                 <p className='mt-1 text-xs text-destructive'>{errors.confirmPassword.message}</p>
//               )}
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className='flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3 pt-6'>
//             <button
//               type='button'
//               onClick={onClose}
//               className='flex-1 px-4 py-2 border border-border rounded-md text-foreground hover:bg-accent transition-colors'
//               disabled={isPending}
//             >
//               Cancel
//             </button>

//             <button
//               type='submit'
//               className='flex-1 flex items-center justify-center px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
//               disabled={isPending}
//             >
//               {isPending ? (
//                 <div className='flex items-center justify-center'>
//                   <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-primary-foreground mr-2' />
//                   Adding...
//                 </div>
//               ) : (
//                 <div className='flex items-center justify-center'>
//                   <UserRoundPlus size={16} className='mr-2' />
//                   Add Admin
//                 </div>
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };



import React, { useEffect, useState } from 'react';
import { Icon, UserRoundPlus, X, Eye, EyeOff } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useCreateAdmin } from '../hooks/useAdminMutations';
import { useRoles } from 'features/role/hooks/useRoles';

// Zod validation schema
const adminSchema = z
  .object({
    name: z
      .string()
      .min(1, 'Name is required')
      .min(2, 'Name must be at least 2 characters')
      .max(50, 'Name must be less than 50 characters'),

    email: z.string().min(1, 'Email is required').email('Invalid email address'),

    phoneNumber: z
      .string()
      .optional()
      .refine((val) => {
        if (!val || val.trim() === '') return true;
        return /^[6-9]\d{9}$/.test(val);
      }, {
        message: 'Enter a valid Indian phone number',
      }),

    role: z.string().min(1, 'Role is required'),

    password: z
      .string()
      .min(1, 'Password is required')
      .min(8, 'Password must be at least 8 characters')
      .max(100, 'Password must be less than 100 characters'),

    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  });

export const AddAdminModal = ({ isOpen, onClose }) => {
  const { mutate: createAdmin, isPending } = useCreateAdmin();
  const { data: roles } = useRoles({ limit: 99, isActive: true });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(adminSchema),
    mode: 'onChange',
    defaultValues: {
      name: '',
      email: '',
      phoneNumber: '',
      password: '',
      confirmPassword: '',
      role: '',
    },
  });

  useEffect(() => {
    if (!isOpen) {
      reset();
      setShowPassword(false);
      setShowConfirmPassword(false);
    }
  }, [isOpen, reset]);

  const onSubmit = (data) => {
    const { phoneNumber, ...submitData } = data;
    const finalData = phoneNumber ? { ...submitData, phoneNumber } : submitData;

    createAdmin(finalData, {
      onSuccess: () => {
        onClose();
        reset();
      },
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm overflow-y-auto">
      <div className="bg-card rounded-lg shadow-xl w-full max-w-2xl border border-border my-8">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-border">
          <h3 className="text-lg font-semibold text-foreground">
            Add New Admin
          </h3>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
            type="button"
          >
            <X size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit(onSubmit)} className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Name */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Name <span className="text-destructive">*</span>
              </label>
              <input
                type="text"
                {...register("name")}
                className={`w-full px-3 py-2 ${errors.name ? "border-destructive" : ""}`}
                placeholder="Enter admin name"
              />
              {errors.name && (
                <p className="mt-1 text-xs text-destructive">
                  {errors.name.message}
                </p>
              )}
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Email <span className="text-destructive">*</span>
              </label>
              <input
                type="email"
                {...register("email")}
                className={`w-full px-3 py-2 ${errors.email ? "border-destructive" : ""}`}
                placeholder="admin@example.com"
              />
              {errors.email && (
                <p className="mt-1 text-xs text-destructive">
                  {errors.email.message}
                </p>
              )}
            </div>

            {/* Phone */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Phone Number{" "}
                <span className="text-muted-foreground text-xs">
                  (Optional)
                </span>
              </label>
              <input
                type="tel"
                {...register("phoneNumber")}
                className={`w-full px-3 py-2 ${errors.phoneNumber ? "border-destructive" : ""}`}
                placeholder="9876543210"
              />
              {errors.phoneNumber && (
                <p className="mt-1 text-xs text-destructive">
                  {errors.phoneNumber.message}
                </p>
              )}
            </div>

            {/* Role */}
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Role <span className="text-destructive">*</span>
              </label>
              {/* <select {...register('role')} className={`w-full px-3 py-2 ${errors.role ? 'border-destructive' : ''}`}>
                <option value=''>Select a role</option>
                {roles?.data?.map((role) => (
                  <option key={role._id} value={role._id}>
                    {role.name}
                  </option>
                ))}
              </select> */}

              <select
                {...register("role")}
                className={`w-full px-3 py-2 ${errors.role ? "border-destructive" : ""}`}
              >
                <option value="">Select a role</option>

                {roles?.data
                  ?.filter((role) => role.name !== "sub_admin")
                  .map((role) => (
                    <option key={role._id} value={role._id}>
                      {role.name
                        ?.split("_")
                        .map(
                          (word) =>
                            word.charAt(0).toUpperCase() + word.slice(1),
                        )
                        .join(" ")}
                    </option>
                  ))}
              </select>
              {errors.role && (
                <p className="mt-1 text-xs text-destructive">
                  {errors.role.message}
                </p>
              )}
            </div>

            {/* Password */}
            <div className="relative">
              <label className="block text-sm font-medium text-foreground mb-1">
                Password <span className="text-destructive">*</span>
              </label>
              <input
                type={showPassword ? "text" : "password"}
                {...register("password")}
                className={`w-full px-3 py-2 pr-10 ${errors.password ? "border-destructive" : ""}`}
                placeholder="Min. 8 characters"
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-3 top-9 text-gray-500 hover:text-gray-700"
                tabIndex={-1}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
              {errors.password && (
                <p className="mt-1 text-xs text-destructive">
                  {errors.password.message}
                </p>
              )}
            </div>

            {/* Confirm Password */}
            <div className="relative">
              <label className="block text-sm font-medium text-foreground mb-1">
                Confirm Password <span className="text-destructive">*</span>
              </label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                {...register("confirmPassword")}
                className={`w-full px-3 py-2 pr-10 ${errors.confirmPassword ? "border-destructive" : ""}`}
                placeholder="Re-enter password"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                className="absolute right-3 top-9 text-gray-500 hover:text-gray-700"
                tabIndex={-1}
              >
                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
              {errors.confirmPassword && (
                <p className="mt-1 text-xs text-destructive">
                  {errors.confirmPassword.message}
                </p>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3 pt-6">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-border rounded-md text-foreground hover:bg-accent"
              disabled={isPending}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="flex-1 flex items-center justify-center px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 disabled:opacity-50"
              disabled={isPending}
            >
              {isPending ? (
                <div className="flex items-center">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
                  Adding...
                </div>
              ) : (
                <div className="flex items-center">
                  <UserRoundPlus size={16} className="mr-2" />
                  Add Admin
                </div>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};